import api from "../config";
import URLS from "../../constants/urls";
export const _getAllFeedbacks = async (siteId, pageNumber = 0, pageSize = 10) => {
    const response = await api.get(`${URLS.FEEDBACK}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
